import React from 'react'
import ReactDOM from 'react-dom'
import ApolloClient from 'apollo-boost'
import { ApolloProvider, Query } from 'react-apollo'
import { createBrowserHistory } from 'history'
import { Router, Route, Switch, Redirect } from 'react-router-dom'
import moment from 'moment'
import localization from 'moment/locale/it'

// import CircularProgress from 'material-ui/Progress/CircularProgress'
import LinearProgress from 'material-ui/Progress/LinearProgress'

import Login from 'views/Login/Login.jsx'
import App from 'views/App/App.jsx'

import miniMe from 'graphql/queries/miniMe'
import getClientiUI from 'graphql/queries/clientiUI'

import 'assets/scss/material-dashboard-pro-react.css'

moment.locale('it')

const client = new ApolloClient({
  // uri: "http://localhost:3000/graphql"
  // uri: "http://192.168.1.12:8086/graphql",
  uri: 'https://api.crm.casedelparco.it/graphql',
  // uri: "http://192.168.1.101:8087/graphql",
  // uri: "http://127.0.0.1:8081/graphql",
  request: async (operation) => {
    const token = localStorage.getItem('cdpcrm_token')
    operation.setContext({
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    })
  },
  onError: ({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      console.log(graphQLErrors)
    }
    if (networkError) {
      console.log('Net error', networkError)
    }
  },
  clientState: {
    defaults: {
      clientiUI: {
        __typename: 'ClientiUI',
        sortFields: ['daRicontattare_DESC', 'nome_ASC', 'dataUltimaRichiesta_DESC'],
        searchQuery: '',
        searchQueryDebounced: '',
        onlyDaRicontattare: false,
        zona: '',
        interesse: '',
        zonaEsclusa: '',
        interesseEscluso: '',
        page: 1,
      },
    },
    resolvers: {
      Mutation: {
        updateClientiUI: (_, { clientiUI }, { cache }) => {
          const previous = cache.readQuery({ query: getClientiUI }).clientiUI

          const data = {
            clientiUI: {
              __typename: 'ClientiUI',
              ...previous,
              ...clientiUI,
            },
          }
          //console.log(data)
          cache.writeData({ data })
          return null
        },
      },
    },
  },
})

const hist = createBrowserHistory()

const CdpApp = () => (
  <Router history={hist}>
    <ApolloProvider client={client}>
      <Switch>
        <Route exact path="/" component={Login} />
        <Route exact path="/lock-screen" component={Login} />
        <Query query={miniMe}>
          {({ loading, error, data }) => {
            if (loading) return <LinearProgress />

            return <Route path="/" render={(props) => (data ? <App {...props} /> : <Redirect to="/" />)} />
          }}
        </Query>
      </Switch>
    </ApolloProvider>
  </Router>
)

ReactDOM.render(<CdpApp />, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js